import { Link } from 'react-router-dom'
import { useLanguage } from '../i18n/LanguageProvider'

const buildInfo = [
  __APP_VERSION__,
  __GIT_BRANCH__,
  __BUILD_DATE__.replace('T', ' ').slice(0, 19) + 'Z',
  __BUILDER__,
  import.meta.env.MODE,
].join('  ·  ')

export default function Footer() {
  // Phase 95: l'adresse, le copyright et la ligne de build ne sont PAS des
  // chaînes traduisibles — seule « Mentions légales » l'est.
  const { t } = useLanguage()
  // Phase 30 plan 30-1 D-F04: read VITE_ENVIRONMENT at render time so tests
  // can flip it via vi.stubEnv(). Reading at module scope would lock the
  // value at import time and tests would not see the stubbed env.
  const isStaging = import.meta.env.VITE_ENVIRONMENT === 'staging'

  return (
    <footer className="border-t border-border py-8">
      <div className="max-w-[1100px] mx-auto px-6 flex flex-col gap-4">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 text-sm text-text-muted">
          <div className="flex flex-col gap-0.5">
            <span>&copy; 2026 SweatStudio</span>
            <span>1 bis Rue Riboutté, 75009 Paris</span>
          </div>
          <div className="flex items-center gap-3">
            {isStaging && (
              <span className="bg-yellow-400 text-black text-xs font-bold tracking-wider px-2 py-0.5 rounded">
                STAGING
              </span>
            )}
            <Link to="/mentions-legales" className="text-text-muted hover:text-accent">
              {t('footer.legal')}
            </Link>
          </div>
        </div>
        <p className="font-mono text-[10px] text-text-muted/70 select-all break-all">
          {buildInfo}
        </p>
      </div>
    </footer>
  )
}
